<h1 style="margin-left:16px">Resend notifications</h1>

<div class="view-feedback-dialog">
        <owc-card class="one-card-flat" style="position: relative;">
            <owc-table>
              <!-- Table Header -->
              <owc-table-header sticky style="z-index: 1; border-bottom: none; box-shadow: none;">
                <owc-table-header-cell sortable [align]="'left'" (sortOrderChange)="onSort('CustomerId', $event.detail)">
                  Account ID
                </owc-table-header-cell>
      
                <owc-table-header-cell sortable [align]="'left'" (sortOrderChange)="onSort('CustomerName', $event.detail)">
                  Account Name
                </owc-table-header-cell>
      
                <owc-table-header-cell sortable [align]="'left'" (sortOrderChange)="onSort('CustomerContactName', $event.detail)">
                  Account Contact Name
                </owc-table-header-cell>
      
                <owc-table-header-cell sortable [align]="'left'" (sortOrderChange)="onSort('CustomerContactEmail', $event.detail)">
                  Account Contact Email
                </owc-table-header-cell>
              </owc-table-header>
      
              <!-- Table Body -->
              <owc-table-body>
                @for (element of tableData; track $index) {
                  <owc-table-row>
                    <owc-table-simple-cell [title]="element.CustomerId" class="truncate-text">
                      <div class="truncate-text">{{ element.CustomerId }}</div>
                    </owc-table-simple-cell>
      
                    <owc-table-simple-cell [title]="element.CustomerName" class="truncate-text">
                      <div class="truncate-text">{{ element.CustomerName }}</div>
                    </owc-table-simple-cell>
      
                    <owc-table-simple-cell [title]="element.CustomerContactName" class="truncate-text">
                      <div class="truncate-text">{{ element.CustomerContactName }}</div>
                    </owc-table-simple-cell>
      
                    <owc-table-simple-cell [title]="element.CustomerContactEmail" class="truncate-text">
                      <div class="truncate-text">{{ element.CustomerContactEmail }}</div>
                    </owc-table-simple-cell>
                  </owc-table-row>
                }
              </owc-table-body>
            </owc-table>
          </owc-card>
   

    <div style="display: flex">
        <div class="right-button" class="button-group">
          <owc-button class="btn secondary" (click)="onCancel()">Cancel</owc-button>
          <owc-button class="btn primary" mat-stroked-button one-secondary-button (click)="resend()">Resend</owc-button>
        </div>
    </div>
</div>
